import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ProductPublicModels } from '@features/products/product';

@Component({
    standalone: true,
    selector: 'product-fit-size-message',
    templateUrl: './product-fit-size-message.component.html',
    imports: [TranslateModule],
})
export class FitSizeMessageComponent {
    public measurementLabel = input<string>();

    public measurement = input<{ modelHeigh: string; modelSize: string }>();

    public product = input<ProductPublicModels.PublicApiProduct>();
}
